module.exports = __webpack_public_path__ + "static/media/btn-mapa.26cf6880.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/templates/AboutUs/images/btn-mapa.jpg
// module id = 1606
// module chunks = 0